import React, { FC } from "react";

import Svg from "./Svg";
import colors from "../../utils/colorConstants";

interface Props {
  width: string;
  height: string;
  fill?: string;
  className?: string;
}

const Instagram: FC<Props> = ({
  className,
  height,
  width,
  fill = colors.lapel,
}) => {
  return (
    <Svg
      className={className}
      height={height}
      width={width}
      viewBox="0 0 16 16"
      title="Instagram icon"
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M14.1 0H1.9A1.9 1.9 0 000 1.9v12.2C0 15.15.85 16 1.9 16h12.2a1.9 1.9 0 001.9-1.9V1.9A1.9 1.9 0 0014.1 0zm-2.6 2.5c0-.28.22-.5.5-.5h1.5c.28 0 .5.22.5.5V4a.5.5 0 01-.5.5H12a.5.5 0 01-.5-.5V2.5zM8.02 4.95a3.07 3.07 0 110 6.15 3.07 3.07 0 010-6.15zM14.5 14a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5V6.5h2a3.05 3.05 0 00-.35 1.52 4.87 4.87 0 009.74 0c0-.45-.07-1.13-.39-1.52h2V14z"
      />
    </Svg>
  );
};

export default React.memo(Instagram);
